module.exports = __webpack_public_path__ + "img/payment-method-card.1f3fbbd6.svg";